import React, {Fragment} from "react";
import ListView from "../../../components/ContentDisplay/ListView";
import {InventoryReportsCard} from "./inventoryReportsCard";
import {LIST_HEADERS, SORTABLE_FIELDS} from "./inventoryReportsTable.constants";
import {useInventoryReportsSearchOptions} from "./useInventoryReportsSearchOptions";
import {useInventoryReportsTableData} from "./useInventoryReportsTableData";

const InventoryReportsTable = ({onFiltersChange}) => {
  const {inventoryReports, handleSearch, paginationConfig, totalCount} =
    useInventoryReportsTableData(onFiltersChange);
  const {searchOptions} = useInventoryReportsSearchOptions();

  return (
    <Fragment>
      <ListView
        cardContent={InventoryReportsCard}
        handleSearch={handleSearch}
        listHeaders={LIST_HEADERS}
        listItems={inventoryReports}
        searchOptions={searchOptions}
        searchPlaceHolder={"Filter Inventory Reports"}
        sortableFields={SORTABLE_FIELDS}
        totalCount={totalCount}
        withPagination={paginationConfig}
        withSearchQuery={true}
      />
    </Fragment>
  );
};

export default InventoryReportsTable;
